import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)

// преобразование даты gmt+3 в локальную таймзону
export const getTimeByTimeZone = (dateString: string | undefined) => {
  if (!dateString) return ''
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const date = dayjs(dateString).utc()

  const offset = date.tz(userTimeZone).utcOffset()

  const localTime = date.utcOffset(offset).format()

  return localTime
}
